module.exports = __webpack_public_path__ + "static/img/news_bg.26e9870.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/news_bg.png
// module id = fqCW
// module chunks = 9